import { render } from "./CostosPersonalCat.vue?vue&type=template&id=3b094cb2&scoped=true"
import script from "./CostosPersonalCat.vue?vue&type=script&lang=js"
export * from "./CostosPersonalCat.vue?vue&type=script&lang=js"

import "./CostosPersonalCat.vue?vue&type=style&index=0&id=3b094cb2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3b094cb2"

export default script